/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.testimonials-slider .testimonials .testimonials-group' ).each( function( key, val ) {
        if ( key % 2 === 0 ) {
          const autoplaySpeed = 1000;
          const autoplayOn = true;

          const $slickRoot = $( this );

          $slickRoot.on( 'init', function() {
            const $slickList = $slickRoot.find( '.slick-list' );
            $slickList.height( $slickList.parent().height() );
          } );

          $slickRoot.slick( {
            dots: false,
            arrows: false,
            autoplay: true,
            speed: 15000,
            autoplaySpeed: autoplaySpeed,
            vertical: true,
            cssEase: 'linear',
            slidesToShow: 3.5,
            centerPadding: '0',
            infinite: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
          } );
        } else {
          const autoplaySpeed = 1000;
          const autoplayOn = true;

          const $slickRoot = $( this );

          $slickRoot.on( 'init', function() {
            const $slickList = $slickRoot.find( '.slick-list' );

            window.setInterval( function() {
              if ( !autoplayOn ) return;
              $slickRoot.slick( 'slickPrev' );
            }, autoplaySpeed );
          } );

          $slickRoot.slick( {
            dots: false,
            arrows: false,
            autoplay: true,
            speed: 15000,
            autoplaySpeed: autoplaySpeed,
            vertical: true,
            cssEase: 'linear',
            slidesToShow: 3.5,
            centerPadding: '0',
            infinite: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: false,
          } );
        }
      } );

      $( '.testimonials-slider .testimonials.is-mobile' ).each( function( key, val ) {
        $( this ).slick( {
          dots: false,
          arrows: false,
          autoplay: true,
          centerMode: true,
          autoplaySpeed: 8000,
          infinite: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
